import { Paper } from '@ui';
import styled from 'styled-components';

export const KycVerificationSC = styled(Paper)`
  margin-top: 124px;
`;
